import React, { useState } from "react";
import { Center, Box, Grid, GridItem, Text, Input, Button, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { HmacMD5 } from "crypto-js";

// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

export default function Debtors() {    
    
    // Set small screen size
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 700px)"
    });

    // Set Count Variable
    var count = 0;
    
    // Set state variables
    const [accessToken , setAccessToken] = useState(null);
    const [sharedToken , setSharedToken] = useState(null);
    const [emailAddress , setEmailAddress] = useState(null);
    const [tokenExecuted, setTokenExecuted] = useState(false);
    const [submittedDetails, setSubmittedDetails] = useState(false);
    const [reference, setReference] = useState(null);
    const [pleaseWait, setPleaseWait] = useState(false);

    if (!tokenExecuted) {
        retreiveAccessToken();
        
        var thisReference = "INV-DBT" + new Date().getTime();
        setReference(thisReference);
    }
    
    function retreiveAccessToken() {        
        // Retreive Access Token for payment.
        fetch(baseUrl + "debtors/fz-access-token", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setAccessToken(response.access_token);
            setSharedToken(response.shared_secret);
        })
        .catch(error => console.log(error));

        setTokenExecuted(true);
    }

    // Called when clicking submit and pay button
    function handleValidation() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var accountName = document.getElementById("accountName");
        var accountNumber = document.getElementById("accountNumber");
        var invoiceDate = document.getElementById("invoiceDate");
        var invoiceNumber = document.getElementById("invoiceNumber");
        var emailAddress = document.getElementById("emailAddress");
        var amountToPay = document.getElementById("amountToPay");

        // Add all required fields into an array
        var requiredFields = [accountName, accountNumber, invoiceDate, invoiceNumber, emailAddress, amountToPay];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);
        ValidateAmount(amountToPay);

        if (count === 0) {            
            
            if (accessToken != null) {

                var debtorsPaymentModel = JSON.stringify({
                    "accountName": accountName.value,
                    "accountNumber": accountNumber.value,
                    "debtorsInvoiceDate": invoiceDate.value,
                    "emailAddress": emailAddress.value,
                    "debtorsInvoiceNumber": invoiceNumber.value,
                    "accessToken": accessToken,
                    "amount": parseFloat(amountToPay.value).toFixed(2),
                    "invoiceNumber": reference
                });
                
                setEmailAddress(emailAddress.value);
                
                var amount = parseFloat(amountToPay.value * 100).toFixed();

                debtorsPaymentPost(debtorsPaymentModel, amount); 
            }
        }
    }

    // Validation
    function checkInputHasValue(property) {
        if (property.value.length === 0) {
            flagRequired(property);
            count++;
        } else {
            removeFlagRequired(property);
        }
    }

    function flagRequired(property) {
        property.style.borderColor = "red";
    } 

    function removeFlagRequired(property) {
        property.style.borderColor = "lightgray";
    }

    // Validate that the value entered looks like an email address.
    function ValidateEmail(input) {
        // Validation Regular Expression
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;      
        if (!input.value.match(validRegex)) {  
            // If invalid flag that it's required and add to error count      
            flagRequired(input);
            count++;
        } 
    }    

    // Validate that payable amount is greater than 0
    function ValidateAmount(input) {
        if (input.value <= 0) {
            flagRequired(input);
            count++;
        }
    } 

    // Api call
    function debtorsPaymentPost(debtorsPaymentModel, amount) {
        // Store details on property certificate
        // Set please wait for slow browsers
        setPleaseWait(true);
        fetch(baseUrl + "debtors/payments", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: debtorsPaymentModel
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
            if(response.statusCode === 200) {
                navigateToFatZebra(amount);
            }
        })
        .catch(error => {
            // Undo please wait if error
            setPleaseWait(false);
            console.log(error);
        });
    }

    

    function navigateToFatZebra(amount) {
        // Navigate to FatZebra Payment
        var sharedSecret = sharedToken; 
        var fzUsername = "TESTmaitland";
        var paymentUrl = "https://paynow.pmnts-sandbox.io/v2";                
        var returnPath = "https://mcc-ae-nonprod-forms.azurewebsites.net/debtorspaid";
        if (window.location.origin === "https://forms.maitland.nsw.gov.au") {
            fzUsername = "maitlanddebtors";
            paymentUrl = "https://paynow.pmnts.io/v2";
            returnPath = "https://forms.maitland.nsw.gov.au/debtorspaid";
        }

        var encrypted = HmacMD5([reference, amount, 'AUD', returnPath].join(':'),sharedSecret).toString();

        setSubmittedDetails(true);    
        window.top.location.href = `${paymentUrl}/${fzUsername}/${reference}/AUD/${amount}/${encrypted}?return_path=${returnPath}&amp;cards=&amp;show_email=false&amp;enable_sca=false&amp;hide_button=false&amp;tokenize_only=false&amp;hide_logos=true`;
    }

    // Api call
    function deleteDebtorsPaymentPost() {
        // Store details on property certificate
        var parameters = "?emailAddress=" + emailAddress + "&accessToken=" + accessToken;

        fetch(baseUrl + "debtors/payments" + parameters, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
            setPleaseWait(false);
        })
        .catch(error => console.log(error));
        return true;
    }
    
    function handleCancelAndReturn() {
        // Return to page > Delete from Database if not paid > reload page
        setSubmittedDetails(false);
        deleteDebtorsPaymentPost();
        window.location.reload();
    }

    return (
        <>
            <Helmet>
                <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                    connect-src 'self' ${baseUrl}debtors/`} />
            </Helmet>
            {!submittedDetails && 
            <Box marginTop='2%' marginLeft='5%' maxW='90%'>
                <Grid templateColumns='repeat(1, 1fr)' gap={3}>
                    <GridItem w='100%'>
                        <Text fontSize='2xl' fontWeight="bold">Debtor Details</Text>
                    </GridItem>
                    <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Account Name<span className="requiredField">Required</span></Text>
                            <Input id="accountName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                        </GridItem>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Account Number<span className="requiredField">Required</span></Text>
                            <Input id="accountNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type='number' onWheel={(e) => e.target.blur()} />
                        </GridItem>
                    </Grid>
                    <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Invoice Date<span className="requiredField">Required</span></Text>
                            <Input id="invoiceDate" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type='date' />
                    </GridItem>
                    <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Invoice Number<span className="requiredField">Required</span></Text>
                            <Input id="invoiceNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type='number' onWheel={(e) => e.target.blur()} />
                        </GridItem>
                        <GridItem w='100%'>
                            <Text fontSize="md" fontWeight="bold">Email Address<span className="requiredField">Required</span></Text>
                            <Input id="emailAddress" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                        </GridItem>
                    </Grid>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Amount to pay<span className="requiredField">Required</span></Text>
                        <InputGroup>
                            <InputLeftAddon children="$" height="40px" />
                            <Input id="amountToPay" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type="number" onWheel={(e) => e.target.blur()} />
                        </InputGroup>
                    </GridItem>
                    <GridItem w='100%'>
                        <Button w="100%" variant="Primary" padding="25px" onClick={() => handleValidation()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button>
                    </GridItem>
                </Grid>
            </Box>
            }
            {submittedDetails &&
            <>
                <Center>
                    <Button onClick={() => handleCancelAndReturn()} size="lg" variant="Primary">&lt; Back</Button>
                </Center>
            </>
            }
        </>
    )
}